import {
  createSelector,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";

import type { RootState } from "../../app/store";

export interface SliceProps {
  shareModalOpen: boolean;
  shareUrl: string;
  shareTitle: string;
  shareDescription: string;
  shareQrCaption?: string;
}

const initialState: SliceProps = {
  shareDescription: "",
  shareModalOpen: false,
  shareQrCaption: "",
  shareTitle: "",
  shareUrl: "",
};

export const ShareMapSlice = createSlice({
  initialState,
  name: "buildings",
  reducers: {
    closeShareModal: (
      state: SliceProps,
      _action: PayloadAction<SliceProps["shareModalOpen"]>,
    ) => {
      state.shareModalOpen = initialState.shareModalOpen;
      state.shareTitle = initialState.shareTitle;
      state.shareDescription = initialState.shareDescription;
      state.shareUrl = initialState.shareUrl;
      state.shareQrCaption = initialState.shareQrCaption;
    },
    showShareModal: (
      state: SliceProps,
      action: PayloadAction<{
        title: SliceProps["shareTitle"];
        description: SliceProps["shareDescription"];
        url: SliceProps["shareUrl"];
        qrCaption?: SliceProps["shareQrCaption"];
      }>,
    ) => {
      state.shareModalOpen = true;
      state.shareTitle = action.payload.title;
      state.shareDescription = action.payload.description;
      state.shareUrl = action.payload.url;
      state.shareQrCaption = action.payload.qrCaption;
    },
  },
});

// Selectors
const sliceData = (state: RootState) => state.share_map;

/**
 * Returns the open state of share modal
 * @returns Boolean
 */
export const selectShareModalOpen = createSelector(sliceData, (item) => {
  return item.shareModalOpen;
});

export const selectShareModalTitle = createSelector(sliceData, (item) => {
  return item.shareTitle;
});
export const selectShareModalUrl = createSelector(sliceData, (item) => {
  return item.shareUrl;
});
export const selectShareModalDescription = createSelector(sliceData, (item) => {
  return item.shareDescription;
});
export const selectShareModalQrCaption = createSelector(sliceData, (item) => {
  return item.shareQrCaption;
});

// Action creators are generated for each case reducer function
export const { showShareModal, closeShareModal } = ShareMapSlice.actions;

export default ShareMapSlice.reducer;
